import type { LocaleCode, VideoBlock } from '@fixit/bozp-content';
import { useRef } from 'react';
import { resolveLocalized } from '../locale';

/** Interactive engagement widget — reports the first video play via onInteract(block.id). */
export function VideoBlockView({
  block,
  locale,
  onInteract,
}: {
  block: VideoBlock;
  locale: LocaleCode;
  onInteract?: (widgetId: string) => void;
}) {
  const fired = useRef(false);
  const handlePlay = () => {
    if (fired.current) return;
    fired.current = true;
    onInteract?.(block.id);
  };
  return (
    <figure data-block-type="video">
      {/* biome-ignore lint/a11y/useMediaCaption: captions are an authored LocalizedText label, not a track file */}
      <video src={block.src} poster={block.poster} controls onPlay={handlePlay} />
      {block.captions ? <figcaption>{resolveLocalized(block.captions, locale)}</figcaption> : null}
    </figure>
  );
}
